var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16181 7.51597L9.05951 1.61145C9.46332 1.12463 10.212 1.13028 10.6084 1.62313L15.3339 7.49805C15.672 7.91839 15.3728 8.54306 14.8333 8.54306C14.314 8.54306 14.0093 9.1273 14.3066 9.55314L16.5532 12.7718C16.8941 13.2603 16.5446 13.9305 15.9489 13.9305C15.3271 13.9305 14.9848 14.6531 15.3787 15.1342L17.8058 18.0988C18.3404 18.7516 17.8759 19.7323 17.0321 19.7323H12.2265C11.6742 19.7323 11.2265 20.18 11.2265 20.7323V22.6692C11.2265 23.2215 10.7788 23.6692 10.2265 23.6692H9.6536C9.10132 23.6692 8.6536 23.2215 8.6536 22.6692V20.7323C8.6536 20.18 8.20589 19.7323 7.6536 19.7323H2.2543C1.41052 19.7323 0.946022 18.7516 1.48054 18.0988L3.92169 15.1171C4.30998 14.6428 3.97256 13.9305 3.35961 13.9305C2.76429 13.9305 2.42171 13.2536 2.77421 12.7739L5.14947 9.54111C5.45365 9.12711 5.15803 8.54306 4.6443 8.54306C4.11348 8.54306 3.82292 7.92453 4.16181 7.51597Z",
    stroke: "black",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNature);
export default __webpack_public_path__ + "static/media/nature.269f7d8f5e7c94275eb9b7c94884b80d.svg";
export { ForwardRef as ReactComponent };